var React = require('react');

function Iso (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"id":"e","className":"cls-1","d":"M0,50.59H5.85V4.41H0V0H43.41V14H35.74V4.89H15.89V24H29.1V18.52h5.53V34.43H29.1V28.92H15.89V50.11H36.53V39.87H44.2V55H0Z","key":0}),React.createElement("path",{"id":"d","className":"cls-1","d":"M49,50.59h5.85V4.41H49V0H73.91A30,30,0,0,1,84.38,1.77,22.89,22.89,0,0,1,92.65,7a24,24,0,0,1,5.41,8.63A33.67,33.67,0,0,1,100,27.5a33.59,33.59,0,0,1-1.94,11.9A24,24,0,0,1,92.65,48a22.89,22.89,0,0,1-8.27,5.24A30,30,0,0,1,73.91,55H49Zm15.89-.48H72.4q8.14,0,12.3-4.21t4.15-12.41v-12q0-8.19-4.15-12.41T72.4,4.89H64.89Z","key":1})]));
}

Iso.defaultProps = {"viewBox":"0 0 100 55"};

module.exports = Iso;

Iso.default = Iso;
